module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"static/mstile-310x310.png","name":"NGUdbhav || Udbhav Gambhir","short_name":"NGUdbhav","start_url":"/shopper","background_color":"#151515","theme_color":"#ffa500","display":"standalone","screenshots":[{"src":"static/ss.png","sizes":"640x320","type":"image/png","label":"Shopper Stop","platform":"wide"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"3400a76f9925a748adb1b0be75e81df4"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
